export var actionTypePrefix = '@@config';
export var reduxKey = '@@config';
//# sourceMappingURL=constants.js.map